import { createApiDescription } from "../../helperFunctions";

export const organizerStatusInfo = {
    getOrganizerStatus: createApiDescription(
        "This API is used to fetch the details of organizer status for a given organizer.",
        [
            "Organizer ID can be obtained from GET Organizer APIs or is returned from the Organizer webhook."
        ]
    ),
    updateDocumentStatus: createApiDescription(
        "This API is used to change the statuses of signature, organizer and source document to downloaded.",
        [
            "Status of the documents will be changed to downloaded only if for applicable cases like Esigned/completed/uploaded by the clients. This API changes the status to downloaded in the grid, download documents popup and update required entries in client tracking as well."
        ]
    )
}